import React from 'react';

export const DisclaimerText = () => {
  return (
    <div className='privacy-policy-container'>
      <h1 className='privacy-policy-header'>Privacy Policy</h1>

      <p>Patrick Lewis built the following apps:</p>
      <ul>
        <li>Sunrock Protector</li>
        <li>Paddle Baddle</li>
        <li>AstroVolts</li>
        <li>WebWhacker</li>
      </ul>

      <p>
        These apps are provided by Patrick Lewis at no cost and are intended for use as is.
        Some apps are ad-supported, and some include optional in-app purchases, as described below.
      </p>

      <p>
        This page is used to inform visitors regarding my policies with the collection, use,
        and disclosure of Personal Information if anyone decides to use my Service.
      </p>

      <p>
        If you choose to use my Service, then you agree to the collection and use of information
        in relation to this policy. I do not collect or store personal data directly.
        Any information that is collected is handled by third-party services as described below
        and is used for providing and improving the Service.
      </p>

      <p>
        The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions,
        which are accessible in all apps unless otherwise defined in this Privacy Policy.
      </p>

      <h2 className='privacy-policy-header'>App-Specific Data Use</h2>

      <h3>Sunrock Protector</h3>
      <ul>
        <li>Displays AdMob advertisements</li>
        <li>Includes optional in-app purchases</li>
      </ul>
      <p>
        Advertising and purchase-related data may be collected and processed by third-party
        services such as Google AdMob, Apple App Store, and Google Play Billing.
        I do not collect or store this information myself.
      </p>

      <h3>Paddle Baddle</h3>
      <ul>
        <li>Displays AdMob advertisements</li>
        <li>Does not include in-app purchases</li>
      </ul>

      <h3>AstroVolts</h3>
      <ul>
        <li>Displays AdMob advertisements</li>
        <li>Does not include in-app purchases</li>
      </ul>

      <h3>WebWhacker</h3>
      <ul>
        <li>Does not display advertisements</li>
        <li>Does not include in-app purchases</li>
        <li>Does not collect personal data</li>
      </ul>

      <h2 className='privacy-policy-header'>Information Collection and Use</h2>

      <p>I do not collect personal information directly from users.</p>

      <p>
        However, apps that include advertising or in-app purchases use third-party services
        that may collect information used to identify you, such as for advertising,
        analytics, crash reporting, and purchase processing.
      </p>

      <p>Third-party service providers used by the apps may include:</p>
      <ul>
        <li>Google Play Services</li>
        <li>Apple App Store Services</li>
        <li>Google Play Billing</li>
        <li>Google AdMob</li>
        <li>Unity Technologies</li>
      </ul>

      <p>
        Each of these services has its own Privacy Policy,
        and I encourage you to review them.
      </p>

      <h2 className='privacy-policy-header'>In-App Purchases</h2>

      <p>In-app purchases are available only in Sunrock Protector.</p>

      <p>
        All in-app purchases are processed by Apple (App Store) or Google (Google Play).
        I do not collect, store, or have access to any payment information,
        such as credit card numbers or billing details.
      </p>

      <p>
        Purchase-related information is handled entirely by Apple or Google
        in accordance with their respective privacy policies.
      </p>

      <h2 className='privacy-policy-header'>Log Data</h2>

      <p>
        In the case of an error in the app, I may receive Log Data through third-party services.
      </p>

      <p>This Log Data may include information such as:</p>
      <ul>
        <li>Device Internet Protocol ("IP") address</li>
        <li>Device name</li>
        <li>Operating system version</li>
        <li>App configuration</li>
        <li>Time and date of use</li>
        <li>Other diagnostic statistics</li>
      </ul>

      <p>This information is used to improve app stability and performance.</p>

      <h2 className='privacy-policy-header'>Cookies</h2>

      <p>
        This Service does not use cookies directly.
        However, third-party SDKs (such as advertising services)
        may use cookies or similar technologies to improve their services.
      </p>

      <p>
        You can manage cookie preferences through your device settings.
        Refusing cookies may affect some functionality.
      </p>

      <h2 className='privacy-policy-header'>Service Providers</h2>

      <p>I may employ third-party companies and individuals to:</p>
      <ul>
        <li>Facilitate the Service</li>
        <li>Provide advertising or purchase processing</li>
        <li>Perform service-related tasks</li>
        <li>Assist in analyzing app performance</li>
      </ul>

      <p>
        These third parties have access to personal information only to perform
        the tasks assigned to them and are obligated not to disclose or use it
        for any other purpose.
      </p>

      <h2 className='privacy-policy-header'>Security</h2>

      <p>
        I value your trust in using this Service and strive to use commercially
        acceptable means of protecting information handled by third parties.
        However, no method of transmission over the internet or electronic storage
        is 100% secure.
      </p>

      <h2 className='privacy-policy-header'>Links to Other Sites</h2>

      <p>
        This Service may contain links to third-party sites.
        I strongly advise you to review their Privacy Policies.
      </p>

      <h2 className='privacy-policy-header'>Children's Privacy</h2>

      <p>These Services do not address anyone under the age of 13.</p>

      <p>
        I do not knowingly collect personally identifiable information
        from children under 13.
      </p>

      <h2 className='privacy-policy-header'>Changes to This Privacy Policy</h2>

      <p>
        I may update this Privacy Policy from time to time.
        Changes are effective immediately after they are posted on this page.
      </p>

      <p>
        <strong>Effective date: 2026-FEB-08</strong>
      </p>

      <h2 className='privacy-policy-header'>Contact Us</h2>

      <p>If you have any questions or suggestions about this Privacy Policy:</p>

      <p>
        📧 <a href="mailto:plataeastudios@gmail.com">plataeastudios@gmail.com</a>
      </p>

      <p>Boston, MA</p>
    </div>
  );
};
